module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-modal",
    class: {
      error: _vm.isError
    },
    attrs: {
      "id": "colabora-modal"
    }
  }, [_c('div', {
    staticClass: "dismiss",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.$t('title')))]), _vm._v(" "), (!_vm.noPublicat()) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('message')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }],
    staticClass: "form-control my-border",
    attrs: {
      "lang": "ca",
      "id": "email",
      "name": "email",
      "type": "text",
      "data-vv-validate-on": "blur",
      "placeholder": _vm.$t('emailPlaceholder'),
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "centered validationErrorMsg"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('emailValidation')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.convidarMapa
    }
  }, [_vm._v(_vm._s(_vm.$t('convidar')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasConvidats),
      expression: "hasConvidats"
    }]
  }, [_c('hr'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('usrConvidats')))]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, _vm._l((_vm.convidats), function(item, index) {
    return _c('li', {
      key: item.email
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.validat === 'N'),
        expression: "item.validat === 'N'"
      }],
      staticClass: "alert alert-danger alert-dismissible",
      attrs: {
        "role": "alert"
      }
    }, [_c('button', {
      staticClass: "close",
      attrs: {
        "type": "button",
        "data-dismiss": "alert",
        "aria-label": "Close"
      },
      on: {
        "click": function($event) {
          _vm.eliminarConvidat(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("clear")])]), _vm._v("\n                    " + _vm._s(item.email) + "\n                ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.validat === 'S'),
        expression: "item.validat === 'S'"
      }],
      staticClass: "alert alert-info",
      attrs: {
        "role": "alert"
      }
    }, [_vm._v("\n                    " + _vm._s(item.email) + "\n                ")])])
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasConvidats),
      expression: "!hasConvidats"
    }]
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('noConvidats')))])])]) : _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('mapaNoPublicat')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f953f1a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/perfil/components/colabora-modal/colabora-modal.vue
// module id = 328
// module chunks = 0